import React, { Fragment } from "react";
import { capitalizeFirstLetter } from "../../common/game/basic";
import { useSelector } from "react-redux";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { formatHandSummary } from "./loggingHelpers";

const Logging = ({ collapsed = false }) => {
  const gameState = useSelector((state) => state.gameState);

  // Compute maxHandId safely (for determining which hand is "current")
  const maxHandId = gameState.HandSteps.length > 0
    ? Math.max(...gameState.HandSteps.map((h) => h.HandId))
    : -1;

  return (
    <div className="bg-black text-light my-top mb-2" data-testid="logging-root">
      {/* Accordion list of hands - hidden when collapsed */}
      {!collapsed && (
      <div className="CustomSideBar">
        {gameState.HandSteps.slice()
          .reverse()
          .map((handStep) => {
            const isCurrent = handStep.HandId === maxHandId;
            return (
              <Accordion
                key={`hand-${handStep.HandId}`}
                defaultExpanded={isCurrent}
                TransitionProps={{ unmountOnExit: true }}
                sx={{
                  backgroundColor: "transparent",
                  color: "inherit",
                  boxShadow: "none",
                  "&:before": { display: "none" },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "inherit" }} />}
                  sx={{
                    minHeight: "32px",
                    "&.Mui-expanded": { minHeight: "32px" },
                    "& .MuiAccordionSummary-content": { margin: "4px 0" },
                  }}
                >
                  {formatHandSummary(handStep)}
                </AccordionSummary>
                <AccordionDetails sx={{ padding: "0 16px 8px" }}>
                  {handStep.BettingRounds.slice()
                    .reverse()
                    .map((roundStep) => (
                      <Fragment key={`hand-${handStep.HandId}-round-${roundStep.RoundId}`}>
                        {roundStep.AfterRoundSteps.slice()
                          .reverse()
                          .map((actionStep, stepIndex) => (
                            <Fragment key={`hand-${handStep.HandId}-round-${roundStep.RoundId}-after-${stepIndex}`}>
                              <span
                                className={`d-block log-entry ${
                                  actionStep.Action === "Deal" ||
                                  actionStep.Action === "ReturnToDeck" ||
                                  actionStep.Action === "Discard"
                                    ? "card-action"
                                    : "player-action"
                                }`}
                              >
                                <strong>
                                  {capitalizeFirstLetter(actionStep.PlayerName)}
                                </strong>
                                {" " + actionStep.Description.trim()}
                              </span>
                            </Fragment>
                          ))}
                        <span className="d-block log-entry betting-round">
                          Betting Round: {roundStep.RoundId + 1}
                        </span>
                        {roundStep.BeforeRoundSteps.slice()
                          .reverse()
                          .map((actionStep, stepIndex) => (
                            <Fragment key={`hand-${handStep.HandId}-round-${roundStep.RoundId}-before-${stepIndex}`}>
                              <span
                                className={`d-block log-entry ${
                                  actionStep.Action === "Deal" ||
                                  actionStep.Action === "ReturnToDeck" ||
                                  actionStep.Action === "Discard"
                                    ? "card-action"
                                    : "player-action"
                                }`}
                              >
                                <strong>
                                  {capitalizeFirstLetter(actionStep.PlayerName)}
                                </strong>
                                {" " + actionStep.Description.trim()}
                              </span>
                            </Fragment>
                          ))}
                      </Fragment>
                    ))}
                </AccordionDetails>
              </Accordion>
            );
          })}
      </div>
      )}
    </div>
  );
};

export default Logging;
